import { Component, OnInit } from '@angular/core';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
declare var $: any;

@Component({
  selector: 'app-user-login-history-report',
  templateUrl: './user-login-history-report.component.html',
  styleUrls: ['./user-login-history-report.component.scss']
})
export class UserLoginHistoryReportComponent implements OnInit {
  
  start_date : any = "";
  end_date : any = "";
  disable : boolean = false;
  
  constructor(
    private formateDate: DateFormateService,
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private exportExcelService : ExportExcelService

  ) { }

  ngOnInit() {
    
  }


  selectedDates(dates) {
    if (dates.from) {
      this.start_date = this.formateDate.formateDate(
        dates.from
      );
    }
    if (dates.to) {
      this.end_date = this.formateDate.formateDate(
        dates.to
      );
    }
    if (!dates.from) {
      this.start_date = "";
    }
    if (!dates.to) {
      this.end_date = "";
    }

    if (this.start_date != "" && this.end_date != "") {
      this.disable = true;
    }
  }

  getExceldownloadExcel(){
    this.apiService.get(this.apiConfig.pointsLedgerReport + `?report_id=25&fromdate=${this.start_date}&todate=${this.end_date}`).subscribe((res :any)=>{
      console.log(res.data.report_data)
      this.downloadExcel(res.data.report_data)
    })
  }

  downloadExcel(data){
    let sheetName = "sheet1";
    let filename = "User_Login_History_Report_";
    let excelData = data;
    let excelArray = [
      { header: 'User ID', key: 'user_id'},
      { header: 'Outlet/Osmosys Code', key: 'rocode'},
      { header: 'Outlet Name',key: 'ro_name'},
      { header: 'CSM Name',key: 'user_detail_name'},
      { header: 'CSM Mobile Number', key: 'csm_number'},
      { header: 'State Name', key: 'state_name'},
      { header: 'Login At', key: 'loginat' },
      { header: 'OTP', key: 'otp'},
      { header: 'IP Address', key: 'ipaddress'}
    ]
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
  }

  

}
